jQuery(document).ready(function($) {
    const $sidebar = $('.ecosystem-sidebar');
    const $body = $('body');

    // Guard clause
    if ($sidebar.length === 0) {
        return;
    }

    // Focus trap variables
    let focusableElements;
    let firstFocusable;
    let lastFocusable;
    let previouslyFocused;

    // Open map sidebar
    $(document).on('click', '.js-open-map-sidebar', function(e) {
        e.preventDefault();

        // Store previous focus
        previouslyFocused = this;

        // Get data from trigger
        const $trigger = $(this);
        const name = $trigger.data('name') || '';
        const sidebarImage = $trigger.data('sidebar-image') || '';
        const sidebarLogo = $trigger.data('sidebar-logo') || '';
        const sidebarLogo2 = $trigger.data('sidebar-logo-2') || '';
        const sidebarBio = $trigger.data('sidebar-bio') || '';
        const buttonUrl = $trigger.data('button-url') || '';
        const buttonTitle = $trigger.data('button-title') || '';
        const buttonTarget = $trigger.data('button-target') || '';

        // Populate sidebar content
        $sidebar.find('.ecosystem-sidebar__name').text(name);

        // Set sidebar image
        if (sidebarImage) {
            $sidebar.find('.ecosystem-sidebar__image-wrapper').html(
                '<img src="' + sidebarImage + '" alt="' + name + '">'
            );
        } else {
            $sidebar.find('.ecosystem-sidebar__image-wrapper').empty();
        }

        // Set sidebar logos
        if (sidebarLogo) {
            $sidebar.find('.ecosystem-sidebar__logo-wrapper--1').html(
                '<img src="' + sidebarLogo + '" alt="">'
            );
        } else {
            $sidebar.find('.ecosystem-sidebar__logo-wrapper--1').empty();
        }

        if (sidebarLogo2) {
            $sidebar.find('.ecosystem-sidebar__logo-wrapper--2').html(
                '<img src="' + sidebarLogo2 + '" alt="">'
            );
        } else {
            $sidebar.find('.ecosystem-sidebar__logo-wrapper--2').empty();
        }

        // Set bio
        if (sidebarBio) {
            $sidebar.find('.ecosystem-sidebar__bio').html(sidebarBio);
        } else {
            $sidebar.find('.ecosystem-sidebar__bio').empty();
        }

        // Set button
        if (buttonUrl && buttonTitle) {
            let buttonHtml = '<a href="' + buttonUrl + '" class="button button--primary"';
            if (buttonTarget) {
                buttonHtml += ' target="' + buttonTarget + '"';
                if (buttonTarget === '_blank') {
                    buttonHtml += ' rel="noopener noreferrer"';
                }
            }
            buttonHtml += '>' + buttonTitle + '</a>';
            $sidebar.find('.ecosystem-sidebar__button-wrapper').html(buttonHtml);
        } else {
            $sidebar.find('.ecosystem-sidebar__button-wrapper').empty();
        }

        // Open sidebar
        openSidebar();
    });

    // Close sidebar
    $(document).on('click', '.js-close-map-sidebar', function(e) {
        e.preventDefault();
        closeSidebar();
    });

    // Close on ESC key
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $sidebar.hasClass('is-open')) {
            closeSidebar();
        }
    });

    // Focus trap
    $(document).on('keydown', function(e) {
        if (!$sidebar.hasClass('is-open')) return;

        if (e.key === 'Tab') {
            if (e.shiftKey) {
                if (document.activeElement === firstFocusable) {
                    e.preventDefault();
                    lastFocusable.focus();
                }
            } else {
                if (document.activeElement === lastFocusable) {
                    e.preventDefault();
                    firstFocusable.focus();
                }
            }
        }
    });

    function openSidebar() {
        $sidebar.addClass('is-open');
        $sidebar.attr('aria-hidden', 'false');
        $body.addClass('is-modal');

        // Set up focus trap
        setTimeout(function() {
            focusableElements = $sidebar.find('button, a[href]').filter(':visible');
            firstFocusable = focusableElements.first()[0];
            lastFocusable = focusableElements.last()[0];

            // Focus close button for keyboard users only
            if (document.documentElement.getAttribute('data-whatintent') === 'keyboard') {
                $sidebar.find('.ecosystem-sidebar__close').focus();
            }
        }, 50);
    }

    function closeSidebar() {
        $sidebar.removeClass('is-open');
        $sidebar.attr('aria-hidden', 'true');
        $body.removeClass('is-modal');

        // Return focus for keyboard users only
        if (previouslyFocused && document.documentElement.getAttribute('data-whatintent') === 'keyboard') {
            previouslyFocused.focus();
        }
    }
});
